import { ReactNode } from "react";
import styles from "./StatisticCard.module.scss";

interface Props {
  icon: ReactNode;
  title: string;
  subtitle: string;
  onClick?: () => void;
  active?: boolean;
}

const StatisticCard = ({ icon, title, subtitle, onClick, active }: Props) => {
  return (
    <div className={styles.card} onClick={onClick}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.content}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>
    </div>
  );
};

export default StatisticCard;
